import React, { useContext, useEffect, useState } from 'react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import PropTypes from 'prop-types';
import { PropertyRow } from '@bingads-webui-campaign-react/ui-generator';
import { Shimmer } from '@fluentui/react';
import { ImageListSummaryCardDetails, processImageListModelToViewModel } from '@bingads-webui-campaign-react/pmax-image-experience';

export const Images = ({
  data,
  shouldFetchFromMT,
  cid,
  aid,
  isLogo,
  label,
}) => {
  // get images
  const i18n = useContext(I18nContext);

  const [images, setImages] = useState(shouldFetchFromMT ? {} : data);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (shouldFetchFromMT) {
      setIsLoading(true);
      // fetch images from MT
      processImageListModelToViewModel(data.ImageAssets, cid, aid).on({
        onSuccess: (loadedImageList) => {
          setImages({
            ImageList: loadedImageList,
          });
          setIsLoading(false);
        },
        onError: () => {
          setImages({});
          setIsLoading(false);
        },
      });
    }
  }, [aid, cid, data.ImageAssets, shouldFetchFromMT]);

  return (
    <PropertyRow propertyLabel={{ label }}>
      {
        isLoading
        ? <Shimmer />
        : <ImageListSummaryCardDetails i18n={i18n} images={images} isLogos={isLogo} />
      }
    </PropertyRow>
  );
};

Images.propTypes = {
  data: PropTypes.shape({
    ImageAssets: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  shouldFetchFromMT: PropTypes.bool,
  aid: PropTypes.string,
  cid: PropTypes.string,
  isLogo: PropTypes.bool,
  label: PropTypes.string,
};

Images.defaultProps = {
  data: {},
  shouldFetchFromMT: false,
  aid: null,
  cid: null,
  isLogo: false,
  label: _TL_('Images'),
};
